import { HttpClientModule } from "@angular/common/http";
import { NgModule, LOCALE_ID } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import {
  NgbModule,
  NgbAlertConfig,
  NgbDateAdapter,
  NgbDateNativeAdapter,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import { NguCarouselModule } from "@ngu/carousel";
import {
  RecaptchaLoaderService,
  RecaptchaModule,
  RecaptchaFormsModule,
  RecaptchaSettings,
  RECAPTCHA_SETTINGS,
} from "ng-recaptcha";
import { AppComponent } from "./app.component";
import { AppRoutesModule } from "./app.routes";
import { CONTAINERS, LAYOUTS, SERVICES, PIPES } from "./shared/index";
import { DataSharedService } from "./shared/services/data-shared.service";
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatTreeModule } from "@angular/material/tree";
import { NgbDateOLParserFormatter } from "./shared/directives/ngb-parser/NgbDateParserFormatter";
import { registerLocaleData } from "@angular/common";
import { AngularEditorModule } from "@kolkov/angular-editor";
import localeCo from "@angular/common/locales/es-CO";
import { GoogleChartsModule } from "angular-google-charts";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatChipsModule } from "@angular/material/chips";
import { DatePipe } from "@angular/common";
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import {MatInputModule} from '@angular/material/input';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatBadgeModule } from '@angular/material/badge';


// tslint:disable-next-line:max-line-length
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { NgPipesModule } from "ngx-pipes";
import { MatFormFieldModule } from "@angular/material/form-field";


export function keyReCaptcha() {
  const browserWindow = window || {};
  const browserWindowEnv = browserWindow["__env"] || {};
  // Assign environment variables from browser window to env
  // In the current implementation, properties from env.js overwrite defaults from the EnvService.
  // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
  // tslint:disable-next-line:forin
  for (const key in browserWindowEnv) {
    if (browserWindowEnv.hasOwnProperty(key) && "keyReCaptcha" === key) {
      return window["__env"][key];
    }
  }

  return null;
}

// import 'evaluatex';

// Al registrar la localidad de colombia afecta a todos lo pipe (DatePipe, CurrencyPipe)
registerLocaleData(localeCo, "es-CO");
@NgModule({
  declarations: [
    AppComponent,
    ...CONTAINERS,
    ...LAYOUTS,
    ...PIPES,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatSidenavModule,
    MatTreeModule,
    MatListModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatExpansionModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutesModule,
    NguCarouselModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    NgxSpinnerModule,
    AngularEditorModule,
    AutocompleteLibModule,
    MatDialogModule,
    MatCardModule,
    MatRadioModule,
    GoogleChartsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    MatBadgeModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    NgPipesModule,
    MatFormFieldModule
  ],
  providers: [
    DataSharedService,
    NgbAlertConfig,
    ...SERVICES,
    RecaptchaLoaderService,
    DatePipe,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: keyReCaptcha() } as RecaptchaSettings,
    },
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    {
      provide: NgbDateParserFormatter,
      useFactory: () => new NgbDateOLParserFormatter(),
    },
    { provide: LOCALE_ID, useValue: "es-CO" },
  ],
  bootstrap: [AppComponent],
  entryComponents: [...CONTAINERS],
})
export class AppModule {}
